import React, { useState } from 'react';
import { Download, HelpCircle, Copy, Check, ChevronUp } from "lucide-react";
import { useBusiness } from '../../../../contexts/BusinessContext';

const PrinterClientBottomSheet = () => {
  const { business } = useBusiness();
  const [copied, setCopied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleCopyId = () => {
    navigator.clipboard.writeText(business?.id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      {/* Botón flotante - solo visible cuando el bottom sheet está cerrado */}
      {!isOpen && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40">
          <button
            onClick={() => setIsOpen(true)}
            className="flex items-center gap-2 px-4 py-2 bg-[#10B981] hover:bg-[#059669] text-white rounded-full shadow-lg transition-colors"
          >
            <Download className="w-4 h-4" />
            <span>Cliente de Impresión</span>
          </button>
        </div>
      )}

      {/* Bottom Sheet */}
      <div
        className={`fixed inset-x-0 bottom-0 transform ${
          isOpen ? 'translate-y-0' : 'translate-y-full'
        } transition-transform duration-300 ease-in-out z-50`}
      >
        {/* Overlay */}
        <div
          className={`fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity ${
            isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
          onClick={() => setIsOpen(false)}
        />

        <div className="relative bg-white dark:bg-gray-800 rounded-t-xl shadow-lg max-w-4xl mx-auto">
          {/* Header con botón de cierre */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Cliente de Impresión Tibó
            </h3>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full"
            >
              <ChevronUp className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 space-y-6">
            <p className="text-gray-600 dark:text-gray-400">
              Para conectar tus impresoras térmicas, primero debes instalar este servidor local en la computadora Windows conectada a la misma red que tus impresoras.
            </p>

            {business?.id && (
              <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  ID de tu Negocio
                </label>
                <div className="flex items-center gap-2">
                  <code className="flex-1 text-sm bg-white dark:bg-gray-800 p-2 rounded border dark:border-gray-600">
                    {business.id}
                  </code>
                  <button
                    onClick={handleCopyId}
                    className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                    title="Copiar ID"
                  >
                    {copied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
                  </button>
                </div>
                <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  Necesitarás este ID para configurar el Cliente de Impresión
                </p>
              </div>
            )}

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <button
                onClick={() => alert("La descarga del Cliente de Impresión estará disponible próximamente. Por favor, contacta a soporte para obtener ayuda con la instalación.")}
                className="flex-1 inline-flex items-center justify-center px-4 py-2 bg-[#10B981] hover:bg-[#059669] text-white rounded-lg transition-colors"
              >
                <Download className="w-4 h-4 mr-2" />
                Descargar Cliente (Windows)
              </button>
              <a
                href="https://docs.tibo.app/printer-setup"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 inline-flex items-center justify-center px-4 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                <HelpCircle className="w-4 h-4 mr-1" />
                Ver Guía de Instalación
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrinterClientBottomSheet; 